export const NETWORK_REPLENISHMENT_REFRESH_EVENT = 'network-replenishment:force-refresh';
